import classNames from 'classnames';
import React, { useCallback } from 'react';
import css from './DeletableTextInput.module.scss';
import TextInput, { TextInputType } from '../../../atoms/TextInput';

import deleteIcon from '../../../../public/static/books/delete.png';

interface SimulatedEvent {
  currentTarget: {
    name: string;
    value: string;
  };
}

interface Props {
  disabled?: boolean;
  type?: TextInputType;
  onChange?: (e: React.ChangeEvent<HTMLInputElement> | SimulatedEvent) => void;
  value?: string;
  maxLength?: number;
  name: string;
}

const DeletableTextInput: React.FC<Props> = ({
  disabled,
  name,
  onChange,
  type,
  value,
  ...attr
}) => {
  const handleClick = useCallback(() => {
    if (!disabled && onChange) {
      const simulatedEvent = {
        currentTarget: {
          name: name,
          // NOTE: Change the value of input to empty
          value: '',
        },
      };
      onChange(simulatedEvent);
    }
  }, [disabled, name, onChange]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement & HTMLTextAreaElement>) => {
      if (!disabled && onChange) {
        onChange(e);
      }
    },
    [disabled, onChange],
  );

  const classes = classNames(css.DeletableTextInput, classNames);

  return (
    <span className={classes}>
      <TextInput
        name={name}
        value={value}
        // @ts-expect-error strictFunctionTypes
        onChange={handleChange}
        className={css.DeletableTextInput__Input}
        type={type}
        {...attr}
      />
      <button
        className={css.DeletableTextInput__Button}
        disabled={disabled}
        onClick={handleClick}
      >
        <img
          className={css.DeletableTextInput__Icon}
          src={deleteIcon}
          alt="Delete icon"
        />
      </button>
    </span>
  );
};

export default DeletableTextInput;
